import { useEffect, useState } from 'react';
import placesService, { TopPlace } from '../services/placesService';

// ============================================
// usePlacesTop (2026-09-20) – Top-Orte für „Darts in deiner Stadt“.
// Startseite (60) und Footer (10) nutzen dieselben Daten: EIN Request pro
// Seitenaufruf (Modul-Cache mit geteiltem Promise), Konsumenten schneiden
// sich ihr Limit ab. Fehler → [] (Sektionen blenden sich aus).
// ============================================

/** Seit 2026-09-24 (Marcel, SEO): 60 Orte als horizontaler Slider auf der Startseite; Footer schneidet 10 ab */
export const PLACES_TOP_FETCH_LIMIT = 60;

let cache: TopPlace[] | null = null;
let inflight: Promise<TopPlace[]> | null = null;

/** Lädt einmal pro Modul-Lebensdauer; danach sofort aus dem Cache */
export const loadTopPlaces = (): Promise<TopPlace[]> => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = placesService
      .getTopPlaces(PLACES_TOP_FETCH_LIMIT)
      .then((list) => {
        cache = Array.isArray(list) ? list : [];
        return cache;
      })
      .catch(() => {
        cache = [];
        return cache;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

/** Nur für Tests: Cache zurücksetzen */
export const resetPlacesTopCache = (): void => {
  cache = null;
  inflight = null;
};

export interface PlacesTopState {
  places: TopPlace[];
  loading: boolean;
}

export default function usePlacesTop(limit: number = PLACES_TOP_FETCH_LIMIT): PlacesTopState {
  const [places, setPlaces] = useState<TopPlace[]>(() => (cache ? cache : []));
  const [loading, setLoading] = useState<boolean>(() => cache === null);

  useEffect(() => {
    let cancelled = false;
    loadTopPlaces().then((list) => {
      if (cancelled) return;
      setPlaces(list);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const safeLimit = Number.isInteger(limit) && limit > 0 ? limit : PLACES_TOP_FETCH_LIMIT;
  return { places: places.slice(0, safeLimit), loading };
}
